export default __webpack_public_path__ + "static/media/costilla.3d93519c.png";